import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {MyApp} from './app.component';
import {HttpClient} from "@angular/common/http";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {IonicStorageModule} from "@ionic/storage";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CacheModule} from "ionic-cache";
import {OdConfig as UIOdConfig, UiModule} from "ui-ts"
import {OdConfig, OdModule} from "od-ts"
import {Header} from "@ui/components/header/header";
import {Footer} from "@ui/components/footer/footer";
import {AppRouter} from "@app/app.router";
import {ENV} from '@env';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

@NgModule({
  declarations: [
    MyApp,
    Header,
    Footer
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp),
    CacheModule.forRoot(),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    UiModule.forRoot(new UIOdConfig( ENV.fileUrl, ENV.downloadFileUrl)),
    OdModule.forRoot(
      new OdConfig(ENV.url, ENV.port, ENV.version, ENV.fileUrl, ENV.downloadFileUrl,
        ENV.dbName, ENV.dbLocation, ENV.cacheName, ENV.cacheEncrypted,
        ENV.jabberUrl, ENV.jabberAdminReceiver,ENV.jabberAdminSender, ENV.jabberAnonymous, ENV.jabberConference,
        ENV.defaultLanguage, ENV.languages,ENV.conversationsApi),
    )
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    Header,
    Footer
  ],
  providers: [
    StatusBar,
    SplashScreen,
    TranslateService,
    AppRouter,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts